export enum PaymentExplanationPageButtonStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  FLAT_FEE_AMOUNT = 'flat_fee_amount',
}
